import { Directive, HostListener, Input } from '@angular/core';
import { Gtm } from '@df/module-gtm/gtm.namespace';
import { GtmService } from '@df/module-gtm/gtm.service';
import { LocalGtmService } from './gtm.service.decorator';
@Directive({
    selector: '[gtmTrackNavigationClick]',
    standalone: true
})
export class GtmTrackNavigationClickDirective {
    @Input()
    gtmTrackNavigationClick?: Gtm.INavigationData;
    constructor(private gtmService: GtmService) { }
    /**
     * Click event listener
     */
    @HostListener('click')
    onClick() {
        let data = this.gtmTrackNavigationClick;
        if (data) {
            if (!!data.link_url && !data.link_url.match(/^http/)) {
                data = { ...data, link_url: window.location.origin + data.link_url };
            }
            (this.gtmService as LocalGtmService).handleNavigationClick(data);
        }
    }
}
